import style from "./style.scss";

const reviewTemplate = document.createElement("template");
reviewTemplate.innerHTML = /* html */ `
  <style>
    ${style}
  </style>
  <div class="content">
    <span id="close" class="close">
      x
    </span>
    <p class="mt-auto text-center">Thank you so much! Positive reviews such as yours are essential to our success.</p>
    <p class="text-center">Would you be willing to leave your review on <span id="reviewWebsiteName"></span> for us?</p>
    <div class="mb-auto text-center">
      <a id="reviewWebsite" class="btn" target="_blank">YES</a>
    </div>
  </div>
`;

export { reviewTemplate };
